import { TemplateInstance } from "../TemplateInstance";
import { TemplateModel } from "../TemplateModel";
import { General } from "./General";

export const createTemplateInstance = async (
  data: TemplateModel
): Promise<TemplateInstance> => {
  switch (data.TemplateName) {
    case "119240000":
      return new General(data.TemplateCode ?? "General1");
    default:
      return new General("General1");
  }
};
